// sendEmail.jsx
import { backendUrl } from './config';

async function sendEmail(userEmail, userName, password) {
    const mailOptions = {
        userEmail,
        userName,
        password
    };
    try {
        const response = await fetch(`${backendUrl}/send-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mailOptions),
        });
        const data = await response.json();
        if (response.ok) {
            return data.message;
        } else {
            return `Error: ${data.message}`;
        }
    } catch (error) {
        console.error("Error sending email:", error);
        return "Error: Error sending data to the server.";
    }
}

export { sendEmail };
